import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {navigator, router} from 'lit-element-router';

import store from '../../store';

import style from '../../../../scss/signup.scss';
import {signup} from '../../slices/accountSlice';
import getRoutes from '../../routes';
import arrowRight from '../../icons/arrowRight';
import {navigateTo} from '../../slices/statusSlice';

@customElement('arc-signup')
export class Signup extends connect(store)(router(navigator(LitElement))) {
	static styles = [style];


	static properties = {
		email: {type: String},
		firstName: {type: String},
		lastName: {type: String},
		isOrgMember: {type: Boolean},
		organization: {type: String},
		defaultLang: {type: String},
		membershipNumber: {type: String},
	};
	constructor() {
		super();
		this.email = '';
		this.firstName = '';
		this.lastName = '';
		this.defaultLang = 'de';
		this.isOrgMember = false;
		this.organization = '';
		this.membershipNumber = '';
		store.subscribe(() => this.requestUpdate());
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.route = route;
		this.params = params;
		this.query = query;
	}

	stateChanged(state) {
		console.log('stateChanged signup', state);
		this.status = state.status;
		this.inputErrors = state.account.data.errors?.input?.params;
	}

	async connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	onEmailInput(value) {
		this.email = value;
		// store.dispatch(setLoginEmail({loginEmail: value}));
		// accountMiddleware will handle success/error
	}
	onFirstNameInput(value) {
		this.firstName = value;
	}
	onLastNameInput(value) {
		this.lastName = value;
	}
	onDefaultLangInput(value) {
		this.defaultLang = value;
	}
	onIsOrgMemberInput(value) {
		this.isOrgMember = value === 1;
	}
	onOrganisationInput(value) {
		this.organization = value;
	}
	onMembershipNumberInput(value) {
		this.membershipNumber = value;
	}

	async onSignUp() {
		console.log('onSignUp');
		await store.dispatch(
			signup({
				email: this.email,
				firstName: this.firstName,
				lastName: this.lastName,
				defaultLang: this.defaultLang,
				isOrgMember: this.isOrgMember,
				orgInfo: {
					organization: this.organization,
					membershipNumber: this.membershipNumber,
				},
			})
		);
		console.log('onSignUp done');
	}
	onRequestCode() {
		store.dispatch(navigateTo({route: 'home', params: this.params}));
	}
	isSignupPossible() {
		return this.email !== '' && this.firstName !== '' && this.lastName !== '' &&
			(this.isOrgMember === false || (this.isOrgMember === true && this.organization !== '' && this.membershipNumber !== ''));
	}
	render() {
		console.log('render signup');
		const state = store.getState();

		return html`
			<arc-welcome>

				<div class="signup">
					<h1 class="title">${msg('Sign Up')}</h1>
					<p>
						${msg('Enter your eMail and name to create an account')}
					</p>
					<arc-text-input
						title="${msg('E-Mail')}"
						required="true"
						placeholder="${msg('Your Email')}"
						.value=${this.email}
						.errors=${this.inputErrors?.email?.errors}
						@value-change=${(e) => this.onEmailInput(e.detail.value)}>
					</arc-text-input>
					<div class="name">
						<arc-text-input
							title="${msg('First Name')}"
							placeholder="${msg('Your First Name')}"
							required="true"
							.value=${this.firstName}
							.errors=${this.inputErrors?.firstName?.errors}
							@value-change=${(e) => this.onFirstNameInput(e.detail.value)}>
						</arc-text-input>
						<arc-text-input
							title="${msg('Surname')}"
							placeholder="${msg('Your Surname')}"
							required="true"
							.value=${this.lastName}
							.errors=${this.inputErrors?.lastName?.errors}
							@value-change=${(e) => this.onLastNameInput(e.detail.value)}>
						</arc-text-input>
					</div>
					<arc-checkbox
						title="${msg('I am member of an association')}"
						tooltip="${msg('association_info_tooltip')}"
						.noFieldTitle=${true}
						.value=${this.isOrgMember}
						.errors=${this.inputErrors?.isOrgMember?.errors}
						@value-change=${(ev) => this.onIsOrgMemberInput(ev.detail.value)}>
					</arc-checkbox>

					${when(this.isOrgMember, () => html`
						<arc-text-input
							title="${msg('Association Name')}"
							required="true"
							placeholder="${msg('Name of the Association')}"
							.value=${this.organization}
							.errors=${this.inputErrors?.organization?.errors}
							@value-change=${(e) => this.onOrganisationInput(e.detail.value)}>
						</arc-text-input>
						<arc-text-input
							title="${msg('Association Membership Nr')}"
							required="true"
							placeholder="${msg('Your Membership Nr')}"
							.value=${this.membershipNumber}
							@value-change=${(e) => this.onMembershipNumberInput(e.detail.value)}>
						</arc-text-input>
					`)}
					<arc-button
						class="submitButton"
						@click=${this.onSignUp}
						title="${msg('Sign Up')}"
						type="primary"
						showIcon="true"
						iconColor="ok"
						.disabled=${!this.isSignupPossible()}
						.additionalInfo="${false}">
						${arrowRight}
					</arc-button>
					<arc-button
						@click=${this.onRequestCode}
						title="${msg('Already have an account? Login here')}"
						type="secondary"
						.additionalInfo="${false}">
					</arc-button>
				</div>
			</arc-welcome>
		`;
	}
}
